import { sortBy } from 'es-toolkit/compat';

import { OrderStatusModel } from '@merchant-clients/order';

import { FilterDialogShell } from '@frontend/components';
import { toFormPlaceIds, toPersistedPlaceIds } from '@frontend/utils';

import { OrderFilterContent } from './order-filter-content.component';
import { OrderFilterInput } from './order-filter-input.interface';

const statuses: OrderStatusModel[] = [
  'PENDING',
  'CONFIRMED',
  'READY',
  'CLOSED',
  'REFUNDED',
  'REJECTED',
];
export interface FilterDialogProps {
  initialValues: OrderFilterInput;
  open: boolean;
  onClose(): void;
  onSubmit?(input: OrderFilterInput): void;
}

export const FilterDialog = (props: FilterDialogProps) => (
  <FilterDialogShell<OrderFilterInput>
    open={props.open}
    onClose={props.onClose}
    initialValues={{
      ...props.initialValues,
      status: statuses.every((s) =>
        props.initialValues.status.includes(s as OrderStatusModel),
      )
        ? ['ALL']
        : props.initialValues.status,
      placeIds: toFormPlaceIds(props.initialValues.placeIds),
      period: props.initialValues.period || 'TODAY',
    }}
    onSubmit={(values) =>
      props.onSubmit?.({
        ...values,
        placeIds: toPersistedPlaceIds(values.placeIds),
        status:
          values.status[0] === 'ALL'
            ? statuses
            : sortBy(values.status as OrderStatusModel[], (status) =>
                statuses.indexOf(status),
              ),
      })
    }
    width={720}
    submitAction="save"
  >
    <OrderFilterContent />
  </FilterDialogShell>
);
